module.exports = __webpack_public_path__ + "static/media/8s.210409c8.png";